import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import {
  AUTH_TOKEN,
  IS_PASSWORD_SYSTEM_GENERATED,
  IS_PSUEDO_NAME_SYSTEM_GENERATED,
  ACCOUNT_SETUP_COMPLETED,
  SIGNIN,
} from "../constants/Auth";
import { showAuthMessage, authenticated } from "../actions/Auth";

export function* signInWithEmail() {
  yield takeEvery(SIGNIN, function* ({ payload }) {
    const params = payload;
    try {
      const user = yield call(async () => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/user/login`,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              method: "post",
              body: JSON.stringify(params),
            }
          );
          const data = await response.json();
          return data;
        } catch (e) {
          put(showAuthMessage(e));
        }
      });
      localStorage.setItem(AUTH_TOKEN, user.token);
      localStorage.setItem("userid", user.id);
      localStorage.setItem(
        IS_PASSWORD_SYSTEM_GENERATED,
        user.systemGeneratedPassword
      );
      localStorage.setItem(
        IS_PSUEDO_NAME_SYSTEM_GENERATED,
        user.systemGeneratedPseudoName
      );
      localStorage.setItem(
        ACCOUNT_SETUP_COMPLETED,
        user.AccountSetupCompleted
      );
      if (user.id) {
        yield put(authenticated(user));
      } else {
        yield put(authenticated(user));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  });
}

export default function* rootSaga() {
  yield all([fork(signInWithEmail)]);
}
